import isEqual from 'lodash.isequal';
import {
  all,
  AllEffect,
  ForkEffect,
  put,
  PutEffect,
  select,
  SelectEffect,
  takeLatest,
} from 'redux-saga/effects';
import { setCrumbs } from 'b2b-apps/shop/breadcrumbs/redux/actionCreators';
import { UPDATE_CRUMBS } from 'b2b-apps/shop/breadcrumbs/redux/actionTypes';
import { getCrumbs } from 'b2b-apps/shop/breadcrumbs/redux/selectors';
import { CrumbType, UpdateCrumbsAction } from 'b2b-apps/shop/breadcrumbs/redux/types';

function* updateCrumbsSaga(
  action: UpdateCrumbsAction,
): Generator<
  SelectEffect | PutEffect,
  void,
  CrumbType[]
> {
  const { crumbs } = action.payload;
  const currentCrumbs = yield select(getCrumbs);

  if (!isEqual(currentCrumbs, crumbs)) {
    yield put(setCrumbs(crumbs));
  }
}

function* breadcrumbsSaga(): Generator<AllEffect<ForkEffect>, void> {
  yield all([takeLatest(UPDATE_CRUMBS, updateCrumbsSaga)]);
}

export { breadcrumbsSaga };
